import { actionsSelect } from './actions';

const OptionsSelectReducers = {
    [actionsSelect.APPLY_SELECT_SEARCHBOX]: (state, action) => { return { ...state, optionsSelect: action.optionsSelect } },
    [actionsSelect.APPLY_SELECT_MODALE]: (state, action) => { return { ...state, optionsSelectModale: action.optionsSelectModale } },

}

export default OptionsSelectReducers;